import React, { Dispatch, SetStateAction } from 'react';
import { MenuItem, Typography } from '@mui/material';
import { FilterStatus } from 'api/Responses/OrderResponses';
import { SortStatus } from 'api/Responses/SetResponses';
import Button from 'components/Button';
import DropDown from 'components/DropDown/DropDown';
import InputField from 'components/InputField';
import { useLanguage } from 'context/AppContext';
import { StatusFilter } from 'hooks/useDeliveryOrdersList';
import * as Styles from '../DeliveryPortalPage.styles';

interface FileUploadListItemProps {
  filter: StatusFilter;
  setFilter: Dispatch<SetStateAction<StatusFilter>>;
  sort: SortStatus;
  setSort: Dispatch<SetStateAction<SortStatus>>;
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  setRefresh: Dispatch<SetStateAction<boolean>>;
}

const FileUploadFilterBar: React.FC<FileUploadListItemProps> = ({
  filter,
  setFilter,
  sort,
  setSort,
  search,
  setSearch,
  setRefresh,
}) => {
  const [language] = useLanguage();

  return (
    <Styles.FileUploadFilterBarContainer>
      <Styles.FileUploadFilterSearchContainer>
        <InputField
          variant="outlined"
          fullWidth
          placeholder={language.DeliveryPortal.FileUploadListTable.search}
          onChange={e => setSearch(e.target.value as string)}
          value={search}
          type="text"
        />
      </Styles.FileUploadFilterSearchContainer>
      <Styles.FileUploadFilterDropdownsContainer>
        <Button onClick={() => setRefresh(true)}>{language.DeliveryPortal.FileUploadListTable.refresh}</Button>
        <Typography variant="h5" component="h2">
          {language.DeliveryPortal.FileUploadListTable.filter}
        </Typography>
        <DropDown value={filter} variant="outlined" onChange={e => setFilter(e.target.value as StatusFilter)}>
          <MenuItem value={'all'}>{language.DeliveryPortal.FileUploadListTable.all}</MenuItem>
          {Object.values(FilterStatus).map(status => {
            return (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            );
          })}
        </DropDown>
        <Typography variant="h5" component="h2">
          {language.DeliveryPortal.FileUploadListTable.sort}
        </Typography>
        <DropDown value={sort} variant="outlined" onChange={e => setSort(e.target.value as SortStatus)}>
          {Object.values(SortStatus).map(status => {
            return (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            );
          })}
        </DropDown>
      </Styles.FileUploadFilterDropdownsContainer>
    </Styles.FileUploadFilterBarContainer>
  );
};

export default FileUploadFilterBar;
